class CollectionSubscription extends HTMLElement {
    constructor(){
        super();
        this.rcDrawer;
        this.init();
    }

    init(){
        this.rcDrawer = document.querySelector('.product-grid-container.quick-add-drawer-content');
        this.midWidget(this.rcDrawer);
    }

    formatPrice(cents) {
        return (cents / 100).toFixed(2);
    }

    getSellingPlanGroup(product) {
        return product.selling_plan_groups.find(g => g.app_id === 'SKIO') || product.selling_plan_groups[0];
    }

    getVariantAllocations(sellingVariant, sellingPlanGroup) {
        return sellingVariant.selling_plan_allocations.filter(a => a.selling_plan_group_id === sellingPlanGroup.id);
    }

    midWidget(rcWidget){
        let variantID = Number(rcWidget.getAttribute('data-variant-id')),
            productID = rcWidget.getAttribute('data-product-id'),
            productDataEl = rcWidget.querySelector('.custom-widget-product-data'),
            product = JSON.parse(productDataEl.textContent),
            widget = {
                select_subscription_first: true,
                subscribe_message: 'Subscribe & Save',
                subscribe_without_discount_message: 'Subscribe',
                onetime_message: 'One-time purchase'
            };

        let widgetTemplate = rcWidget;
        widgetTemplate.classList.add('radio-group');

        if (product.id != null) {
            widgetTemplate.querySelector('.rc-custom-widget').classList.remove('hidden');
            this.renderWidget(widgetTemplate, variantID, widget, product);
        } else {
            widgetTemplate.querySelector('.rc-custom-widget').classList.add('hidden');
        }
    }

    renderWidget(widgetTemplate, variantID, widget, prod){
        let sellingPlanGroup = this.getSellingPlanGroup(prod),
            sellingVariant = prod.variants.find(obj => obj.id === variantID),
            allocations = this.getVariantAllocations(sellingVariant, sellingPlanGroup),
            sellingPlan = '',
            priceEl,
            price = this.formatPrice(sellingVariant.price),
            compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
            subscribePrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price;

        //subscription is selected first
        if(widget.select_subscription_first){
            sellingPlan = allocations[0].selling_plan_id;
            price = subscribePrice;
        }

        // input element for the selling plan and add it to product form
        let sellingPlanInput = document.createElement('input');
            sellingPlanInput.classList.add('selling-plan-input')
            sellingPlanInput.name = 'selling_plan';
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.value = sellingPlan;
            widgetTemplate.querySelector('.product-form form').appendChild(sellingPlanInput);

        // should change how this
        widgetTemplate.querySelector('.one-time .radio-template .radio').checked = false;
        widgetTemplate.querySelector('.subscription .radio-template .radio').checked = false;


        this.renderSubscriptionRadio(widgetTemplate, widget, prod, sellingVariant, sellingPlanGroup);
        this.renderOneTimeRadio(widgetTemplate, widget, sellingVariant, prod);

        this.renderVariation(widgetTemplate, widget, prod, sellingVariant);

        widgetTemplate.querySelector('.product-form .product-variant-id').addEventListener('change',(ev) => this.updateRadioWidget(prod, widgetTemplate, sellingPlanGroup));
        widgetTemplate.querySelector('.quick-add-close').addEventListener('click',(ev) => this.closeQuickAddDrawer());


        // Update the product price with the correct price
        this.updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice);
    }

    closeQuickAddDrawer() {
        document.getElementById('QuickAddDrawer').classList.remove('active');
        document.getElementById('QuickAddOverlay').classList.remove('active');
    }

    renderVariation(widgetTemplate, widget, prod, sellingVariant){
        let va = widgetTemplate.querySelector('.variant'),
            session = va.getAttribute('data-session'),
            inputs;

        if(va.getAttribute('data-variant-exists') == 'false'){
            inputs = va.querySelectorAll('.variant_input');
            inputs[0].classList.add('selected');
            inputs.forEach(imp => {
                imp.addEventListener('click', (ev) => this.updateVariantInputs(widgetTemplate, imp, prod, session));
            })
        }

    }

    // Function to adjust the footer when bottom nav appears or disappears
    adjustFooterPosition(widgetTemplate) {
        const footer = widgetTemplate.querySelector('.buy-button-wrapper');
        // Detect if the bottom navigation bar is visible (based on window height)
        const isNavBarVisible = window.innerHeight < document.documentElement.clientHeight;

        if (isNavBarVisible) {
            footer.style.transform = 'translateY(-100px)';
        } else {
            footer.style.transform = 'translateY(0)';
        }
    }

    updateVariantInputs(widgetTemplate, imp, prod, session) {
        widgetTemplate.querySelector('.variant_input.selected').classList.remove('selected');
        imp.classList.add('selected');

        widgetTemplate.querySelectorAll(`#${session}`).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = imp.getAttribute('data-variant') ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

    }

    getSellingVariant(prod, variantID) {
        return prod.variants.find(v => v.id === variantID);
    }

    renderSubscriptionRadio(widgetTemplate, widget, prod, sellingVariant, sellingPlanGroup){
        let subscribeText = widget.subscribe_without_discount_message,
            allocations = this.getVariantAllocations(sellingVariant, sellingPlanGroup),
            price = this.formatPrice(sellingVariant.price),
            discountedPrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price,
            compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
            discount = (parseFloat(price) > parseFloat(discountedPrice)),
            subscribePrice = price,
            _this = this;

        // if a discount is applied, change the text to the subscribe with discount message and set the price to the discounted price
        if (discount) {
            subscribePrice = discountedPrice;
            subscribeText = widget.subscribe_message;
            let discountValue = sellingPlanGroup.selling_plans[0].price_adjustments[0].value;
            widgetTemplate.querySelector('.subscription .option-discount').innerText = discountValue + '%'
        }

        widgetTemplate.querySelector('.subscription .option-text').innerHTML = subscribeText;
        widgetTemplate.querySelector('.subscription .option-price').innerText = '$' + subscribePrice

        // //setting subscription radio as the default choice
        if(widget.select_subscription_first){
            widgetTemplate.querySelector('.subscription.radio-wrapper').classList.add('radio-active');
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = true;

            widgetTemplate.setAttribute('data-selected', 'subscription');
            widgetTemplate.querySelector('.price-item.price-item--regular').innerText = '$' + subscribePrice;
        }

        allocations.forEach(item => {
            let option = document.createElement('div'),
                plan = sellingPlanGroup.selling_plans.find(obj => obj.id == item.selling_plan_id),
                discount = plan.price_adjustments[0].value + '%';

            option.className = "delivery"
            option.value = plan.id;
            option.innerText = plan.name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', this.formatPrice(item.price));

            widgetTemplate.querySelector('.shipping-dates').appendChild(option);
        })

        // loop through the variant selling plan allocations selling plans and add them to the dropdown
        allocations.forEach((item) => {
            let option = document.createElement('option'),
                plan = sellingPlanGroup.selling_plans.find(obj => obj.id == item.selling_plan_id),
                discount = plan.price_adjustments[0].value + '%';

            // attach necessary data to the option
            option.value = plan.id;
            option.innerText = plan.name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', this.formatPrice(item.price));

            // append the option to the dropdown
            widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').appendChild(option);
        })

        const deliveryBtn = widgetTemplate.querySelectorAll('.delivery');
        deliveryBtn[0].classList.add('selected');
        deliveryBtn.forEach(btn => {
            btn.addEventListener('click', function(){
                widgetTemplate.querySelector('.shipping-dates .delivery.selected').classList.remove('selected');
                btn.classList.add('selected');
                widgetTemplate.querySelector('.product-form form .selling-plan-input').value = btn.value;
            })
        })

        widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').addEventListener('change', function () {
            widgetTemplate.querySelector('.product-form form .selling-plan-input').value = this.value;
        })

        widgetTemplate.querySelector('.subscription .radio-template .radio').addEventListener('change',(ev) => this.handleSubscriptionChange(ev, widgetTemplate, prod));
    }

    renderOneTimeRadio(widgetTemplate, widget, sellingVariant, prod){
        let price = this.formatPrice(sellingVariant.price),
            oneTimeText = widget.onetime_message;

        widgetTemplate.querySelector('.one-time .option-text').innerText = oneTimeText;
        widgetTemplate.querySelector('.one-time .option-price').innerText = '$' + price;

        if (!widget.select_subscription_first) {
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.add('hidden');
            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.one-time.radio-wrapper').classList.add('radio-active');
            widgetTemplate.setAttribute('data-selected', 'one-time');
        }

        widgetTemplate.querySelector('.one-time .radio-template .radio').addEventListener('change', (ev) => this.handleOneTimeChange(ev, widgetTemplate, widget, prod));
    }


    handleSubscriptionChange(ev, widgetTemplate, prod){
        if (ev.target.checked){
            let sellingPlanGroup = this.getSellingPlanGroup(prod),
                variantID = Number(widgetTemplate.querySelector('.product-form .product-variant-id').value),
                sellingVariant = this.getSellingVariant(prod, variantID),
                allocations = this.getVariantAllocations(sellingVariant, sellingPlanGroup),
                price = this.formatPrice(sellingVariant.price),
                compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
                subscribePrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price,
                sellingPlanInput = widgetTemplate.querySelector('.product-form form .selling-plan-input');


            sellingPlanInput.value = widgetTemplate.querySelector('.shipping-dates .delivery.selected').value

            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = false;
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.remove('hidden')
            widgetTemplate.querySelector('.radio-wrapper.radio-active').classList.remove('radio-active');
            widgetTemplate.querySelector('.subscription.radio-wrapper').classList.add('radio-active');


            widgetTemplate.setAttribute('data-selected', 'subscription');
            this.updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice);
        }
    }

    handleOneTimeChange(ev, widgetTemplate, widget, prod){
        if(ev.target.checked){
            let variantID = Number(widgetTemplate.querySelector('.product-form .product-variant-id').value),
                sellingVariant = this.getSellingVariant(prod, variantID),
                price = this.formatPrice(sellingVariant.price),
                compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
                sellingPlanInput = widgetTemplate.querySelector('.product-form form .selling-plan-input');

            sellingPlanInput.value = '';
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = false;
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.add('hidden');
            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.radio-wrapper.radio-active').classList.remove('radio-active');
            widgetTemplate.querySelector('.one-time.radio-wrapper').classList.add('radio-active');

            // // price update
            widgetTemplate.setAttribute('data-selected', 'one-time');
            this.updatePrice(widgetTemplate, price, null, compareAtPrice);
        }
    }

    updateRadioWidget(prod, widgetTemplate, sellingPlanGroup){
        let variantID = Number(widgetTemplate.querySelector('.product-form .product-variant-id').value),
            sellingVariant = this.getSellingVariant(prod, variantID),
            allocations = this.getVariantAllocations(sellingVariant, sellingPlanGroup),
            priceContainer = widgetTemplate.querySelector('.price'),
             price = this.formatPrice(sellingVariant.price),
            subscribePrice = allocations.length > 0 ? this.formatPrice(allocations[0].price) : price,
            compareAtPrice = sellingVariant.compare_at_price ? this.formatPrice(sellingVariant.compare_at_price) : null,
            subscriptionRadio = widgetTemplate.querySelector('.subscription .radio-wrapper .radio'),
            oneTimeRadio = widgetTemplate.querySelector('.one-time .radio-wrapper .radio'),
            sellingPlanInput = widgetTemplate.querySelector('.product-form form .selling-plan-input');

        priceContainer.classList.add('recharge-price-modifier');

        widgetTemplate.querySelector('.subscription .shipping-dates').innerHTML = ''
        widgetTemplate.querySelector('.subscription .widget__selling-plans-dropdown__select').innerHTML = ''


        allocations.forEach((item, i) => {
            let option = document.createElement('div'),
                plan = sellingPlanGroup.selling_plans.find(obj => obj.id == item.selling_plan_id),
                discount = plan.price_adjustments[0].value + '%';

            if (i === 0) {
                subscribePrice = this.formatPrice(item.price);
                widgetTemplate.querySelector('.subscription .option-price').innerText = '$' + subscribePrice;
            }

            option.className = "delivery"
            option.value = plan.id;
            option.innerText = plan.name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', this.formatPrice(item.price));

            widgetTemplate.querySelector('.subscription .shipping-dates').appendChild(option);
        })

        // loop through the variant selling plan allocations selling plans and add them to the dropdown
        allocations.forEach((item, i) => {
            let option = document.createElement('option'),
                plan = sellingPlanGroup.selling_plans.find(obj => obj.id == item.selling_plan_id),
                discount = plan.price_adjustments[0].value + '%';

            if (i === 0) {
                subscribePrice = this.formatPrice(item.price);
                widgetTemplate.querySelector('.subscription .option-price').innerText = '$' + subscribePrice;
            }

            option.value = plan.id;
            option.innerText = plan.name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', this.formatPrice(item.price));

            widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').appendChild(option);
        })

        widgetTemplate.querySelector('.one-time .option-price').innerText = '$' + this.formatPrice(sellingVariant.price);

        const deliveryBtn = widgetTemplate.querySelectorAll('.delivery');
        deliveryBtn[0].classList.add('selected');
        if(widgetTemplate.getAttribute('data-selected') == 'subscription'){
            widgetTemplate.querySelector('.product-form form .selling-plan-input').value = deliveryBtn[0].value;
        } else if(widgetTemplate.getAttribute('data-selected') == 'one-time'){
            widgetTemplate.querySelector('.product-form form .selling-plan-input').value = '';
        }
        deliveryBtn.forEach(btn => {
            btn.addEventListener('click', function(){
                widgetTemplate.querySelector('.shipping-dates .delivery.selected').classList.remove('selected');
                btn.classList.add('selected');
                widgetTemplate.querySelector('.product-form form .selling-plan-input').value = btn.value;
            })
        })

        widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').addEventListener('change', function () {
            widgetTemplate.querySelector('.product-form form .selling-plan-input').value = this.value;
        })


        this.updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice);
    }

    // updates the price when the variant or selling plan is changed
    updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice) {
        let selected = widgetTemplate.getAttribute('data-selected'),
            priceContainer = widgetTemplate,
            priceEl,
            newPrice;

        if (selected === 'one-time') {
            newPrice = price;
        } else if (selected === 'subscription') {
            newPrice = subscribePrice;
        }

        if (compareAtPrice != null ) {
            priceContainer.querySelector('.price').classList.add('price--on-sale')
            priceEl = priceContainer.querySelector('.price__sale .price-item.price-item--sale');
            priceContainer.querySelector('.price__sale .price-item.price-item--regular').innerText = '$' + compareAtPrice
        } else {
            priceContainer.querySelector('.price').classList.remove('price--on-sale');
            priceEl = priceContainer.querySelector('.price__regular .price-item.price-item--regular');
        }

        priceEl.innerText = '$' + newPrice;
    }
}

customElements.define('collection-subscription', CollectionSubscription);
